/**
 *
 *
 *
 *
 *
 */
export function encodeHtml(html: string | null): string {
    const temporaryElement = document.createElement('div');
    temporaryElement.textContent = html;
    const result = temporaryElement.innerHTML;
    temporaryElement.remove();
    return result;
}

/**
 *
 *
 */
export function encodeHtmlTag(templateStrings: TemplateStringsArray, ...htmlStrings: Array<string | null>): string {
    return templateStrings.raw.reduce((accumulator, currentString, currentIndex) => {
        const htmlString = encodeHtml(htmlStrings[currentIndex - 1]);
        return accumulator + htmlString + currentString;
    });
}
